import { atom, selector } from "recoil";

const localStorageEffect =
  (key) =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue !== null && savedValue !== "undefined") {
      try {
        setSelf(JSON.parse(savedValue));
      } catch (e) {
        console.error(`Error parsing localStorage key "${key}":`, e);
      }
    }
    onSet((newValue, _, isReset) => {
      if (isReset) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };

export const bannedState = atom({
  key: "bannedState",
  default: false,
  effects_UNSTABLE: [localStorageEffect("banned")],
});

export const partyState = atom({
  key: "partyState",
  default: [], // Initial empty array
});

export const notificationsState = atom({
  key: "notificationsState", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
  effects_UNSTABLE: [
    localStorageEffect(
      `notifications_${localStorage.getItem("authUser") || "guest"}`,
    ),
  ],
});

export const messageState = atom({
  key: "messageState", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
  effects_UNSTABLE: [
    localStorageEffect(`messages_${localStorage.getItem("authUser") || "guest"}`),
  ],
});

export const tradesState = atom({
  key: "tradesState", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
  effects_UNSTABLE: [
    localStorageEffect(`trades_${localStorage.getItem("authUser") || "guest"}`),
  ],
});

export const unreadNotificationsCountState = selector({
  key: "unreadNotificationsCountState",
  get: ({ get }) => {
    const notifications = get(notificationsState);
    return notifications.filter((n) => n.viewed === 1).length;
  },
});

export const unreadMessages = selector({
  key: "unreadMessagesCountState",
  get: ({ get }) => {
    const messages = get(messageState);
    return messages.filter((n) => n.view === 0).length;
  },
});

export const unreadTrades = selector({
  key: "unreadTradesCountState",
  get: ({ get }) => {
    const trades = get(tradesState);
    const currentUser = localStorage.getItem("authUser");
    return trades.filter(
      (trade) => trade.recipient_username === currentUser && trade.seen === 0,
    ).length;
  },
});

export const moneyState = atom({
  key: "money",
  default: 0,
  effects_UNSTABLE: [localStorageEffect("money")],
});

export const coinsState = atom({
  key: "coins",
  default: 0,
  effects_UNSTABLE: [localStorageEffect("coins")],
});

export const avatarState = atom({
  key: "avatarState",
  default: 0,
  effects_UNSTABLE: [localStorageEffect("avatar")],
});

export const usernameState = atom({
  key: "usernameState",
  default: "User", // Initial avatar id or value,
  effects_UNSTABLE: [localStorageEffect("username")],
});

export const newState = atom({
  key: "newState",
  default: 1, // Initial avatar id or value,
  effects_UNSTABLE: [localStorageEffect("new")],
});

// WebSocket connection status for notifications
export const notificationWSStatusState = atom({
  key: "notificationWSStatusState",
  default: "connecting",
});
